




















































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AgroInteractiveMapController from "@/components/agroInteractiveMap/AgroInteractiveMapController.vue";
import MonitoringSummaryController from "../monitoring-summary/MonitoringSumaryController.vue";
import * as resultsService from "@/services/results/index";
import * as analysesService from "@/services/analyses/index";
import * as statusService from "@/services/analyses_status/index";
import * as notificationService from "@/services/notification";
import {
  Analysis,
  AnalysisImageAreaData,
  FarmAnalysis,
} from "@/api/analyses/types";
import { FarmAnalysisResult } from "@/api/results/types";
import { AnalysisStatus } from "@/api/analyses_status/types";
import { CropsDTO } from "@/api/crops/types";
import { wrapGeometryObject } from "@/helpers/geojson";
import TemperatureChart from "@/components/temperature-chart/TemperatureChartHCharts.vue";
import SPI4Chart from "@/components/spi4-chart/SPI4ChartHCharts.vue";
import * as weatherService from "@/services/weather/index";
import CarInfractions from "@/views/environmental/components/car-infractions/CarInfractions.vue";
import NdviChartHc from "@/components/ndvi-chart/NdviChartHc.vue";
import YieldEvolutionChartHc from "../yield-evolution-chart/YieldEvolutionChartHc.vue";
import CropsTableController from "../crops-table-controller/CropsTableController.vue";
import TimeLineController from "../time-line-controller/TimeLineController.vue";
import FarmOwnerInfo from "@/components/farmOwnerInfo/FarmOwnerInfo.vue";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { formattedDate, formattedYearsInterval } from "@/filters/date";
import CropIcons from "@/utils/iconCropTypes";
import { percentFilter } from "@/filters/percent";
import Loading from "@/components/loading/Loading.vue";
import { WeatherData } from "@/api/weather/types";
import "vue-nav-tabs/themes/vue-tabs.css";
import AnalysisDelete from "@/components/analyses-delete/AnalysisDelete.vue";
import { RawLocation } from "vue-router";
import LastImageInfo from '../last-image-info/LastImageInfo.vue';
import MonitoringStatus from '../monitoring-status/MonitoringStatus.vue';
import { interpret } from 'xstate';
import { machine as finishMonitoringMachine} from './monitoringcontrol';
import { monitoring } from "@/store/monitoring";
import ConfirmationModal from "@/components/confirmationModal/ConfirmationModal.vue";
import i18n from "@/i18n";
import AdminOnly from "@/components/adminOnly/AdminOnly.vue";
import {AnalysisPaceDTO} from "@/api/pace/types";
import * as paceService from "@/services/pace";
import PaceChartHc from "@/components/pace-chart/PaceChartHc.vue";
import SetteMapsViewerModal from "@/components/setteMapsViewer/SetteMapsViewerModal.vue";
import { checkEmbedAccess, setteMapsEnabled } from "@/api/sette-maps";

const COLORS = ["#eecb11", "#fa14ff", "#00fca1", "#0008fc", "#42f5ff"];
const LEN_COLORS = COLORS.length;

@Component({
  name: "MonitoringViewer",
  components: {
    PaceChartHc,
    AdminOnly,
    InteractiveMap: AgroInteractiveMapController,
    MonitoringSummaryController,
    YieldEvolutionChartHc,
    CropsTableController,
    TimeLineController,
    FarmOwnerInfo,
    AgroIcons,
    TemperatureChart,
    SPI4Chart,
    Loading,
    AnalysisDelete,
    CarInfractions,
    NdviChartHc,
    LastImageInfo,
    MonitoringStatus,
    ConfirmationModal,
    SetteMapsViewerModal
  },
  filters: {
    formattedDate,
    formattedYearsInterval,
    percentFilter,
  },
})
export default class MonitoringViewer extends Vue {
  @Prop({ type: Number, default: () => Math.floor(Math.random() * LEN_COLORS) })
  private colorIndex!: number;

  @Prop({ type: String, default: "" })
  private source?: string;

  private selectedCrops: string[] = [];
  private result: FarmAnalysisResult | null = null;
  private status: AnalysisStatus | null = null;
  private url: string = "";
  private sentinelaLastImageData: AnalysisImageAreaData | null = null;
  private sentinelaPrimeLastImageData: AnalysisImageAreaData | null = null;

  private hovered: string | null = null;
  private polling: number | null = null;

  private farmAnalysisUuid: string | null = null;
  private infractionsGeojson: any[] = [];

  private percentFilterFn = percentFilter;

  private untilDate = new Date();

  private finishMonitoring: any = null;
  
  private updateDialogVisible = false;

  private setteMapsVisible = false;

  // The button shows only after the Sette Maps BFF confirms the user's company (see mounted).
  private setteMapsAllowed = false;
  private setteMapsCheck: AbortController | null = null;

  private hasSummer: boolean = false;
  private hasWinter: boolean = false;
  private harvestSeason: string = this.analysis.harvestSeason;
  
  private annualPace : AnalysisPaceDTO | null = null;
  private cropTypePace : AnalysisPaceDTO | null = null;
  private annualPaceAnalitica : AnalysisPaceDTO | null = null;
  private cropTypePaceAnalitica : AnalysisPaceDTO | null = null;

  private get analysis(): Analysis {
    return this.$store.state.analyses.analysesContext;
  }

  private get isAdmin(): boolean {
    return this.$store.getters["user/isAdminUser"];
  }

  // Asks the Sette Maps BFF whether the logged user's company may open the viewer from this page;
  // the allowlist lives there. Skipped where the viewer is not configured.
  private async checkSetteMapsAccess(): Promise<void> {
    const token = this.$store.state.auth.accessToken;
    if (!setteMapsEnabled() || !token) {
      return;
    }
    const controller = new AbortController();
    this.setteMapsCheck = controller;
    const allowed = await checkEmbedAccess(token, controller.signal);
    if (this.setteMapsCheck === controller) {
      this.setteMapsAllowed = allowed;
      this.setteMapsCheck = null;
    }
  }

  private get sentinelaFarmAnalysis(): FarmAnalysis | null {
    return (
      this.analysis?.farmAnalyses.find(
        (fa) => fa.analysisType === "SENTINELA"
      ) ?? null
    );
  }

  private mountBackLink(): RawLocation {
    if (this.source === "farms-home") {
      return { name: this.source };
    }
    else if (this.source === "sentinela") {
      return { name: this.source };
    }
    else {
      return { name: "farms", params: { ownerUuid: this.analysis.ownerUuid } };
    }
  }

  private showInfractionsInMap(geojson: any) {
    if ([geojson] !== this.infractionsGeojson) {
      this.infractionsGeojson = [geojson];
    }
  }

  private removeInfractionsFromMap() {
    this.infractionsGeojson = [];
  }

  private goBack() {
    const backlink = this.mountBackLink();
    this.$router.replace(backlink);
  }

  @Watch("sentinelaFarmAnalysis", { immediate: true })
  private async sentinelaChanged(sentinelaFarmAnalysis: FarmAnalysis | null) {
    if (!!sentinelaFarmAnalysis) {
      try {
        this.sentinelaLastImageData = (
          await analysesService.getAnalysisImageData(sentinelaFarmAnalysis.uuid)
        )[0];
      } catch (err) {
        this.sentinelaLastImageData = null;
      }

      try {
        this.sentinelaPrimeLastImageData = await analysesService.getSentinelaPrimeLastImageinfo(sentinelaFarmAnalysis.uuid);
      } catch (err) {
        this.sentinelaPrimeLastImageData = null;
      }
    }
  }

  private get analiticaFarmAnalysis(): FarmAnalysis | null {
    return (
      this.analysis?.farmAnalyses.find(
        (fa) => fa.analysisType === "ANALITICA"
      ) ?? null
    );
  }

  get summaryInfo() {
    return this.$store.state.analyses.analysisSummaryContext;
  }

  private get isStillMonitored() {
    return (
      !!this.sentinelaFarmAnalysis &&
      (this.sentinelaFarmAnalysis.analysisYear === 2023 ||
      !this.sentinelaFarmAnalysis.isFinished)
    );
  }

  private created() {
    const machine = finishMonitoringMachine(this.analysis.finished, this.isAdmin);
    this.finishMonitoring = {
      service: interpret(machine),
      current: machine.initialState,
      context: machine.context,
    }
  }
  
  private async updateMonitoring() {
    this.updateDialogVisible = false;
    await analysesService.updateMonitoring(this.analysis.uuid);
    notificationService.addSuccessNotification(i18n.t('monitoring.update.success',) as string);
    setTimeout(function() {window.location.reload()}, 1000);
  }

  private async mounted() {
    // Not awaited: the rest of the screen does not wait for the Sette Maps check.
    this.checkSetteMapsAccess();
    this.finishMonitoring.service
      .onTransition((state: any) => {
        this.finishMonitoring.current = state;
        this.finishMonitoring.context = state.context;
        })
      .start();
    try {
      this.hasSummer = (await resultsService.getFarmAnalysisResultList((this.sentinelaFarmAnalysis as FarmAnalysis).uuid, 'SUMMER')).length > 0;
      this.hasWinter = (await resultsService.getFarmAnalysisResultList((this.sentinelaFarmAnalysis as FarmAnalysis).uuid, 'WINTER')).length > 0;
    } catch(err) {
    }
    await this.loadResult();
    await this.loadStatus();
    this.loadWeatherData();
    if (this.needsTracking) {
      this.trackResult();
    }
    await this.loadPace();
  }

  private async loadPace() {
    if (this.$store.getters["user/isAdminUser"]) {
      let sentinela = this.sentinelaFarmAnalysis;
      let analitica = this.analiticaFarmAnalysis;
      try {
        if (sentinela != null) {
          this.annualPace = await paceService.getByUuid(sentinela.uuid, 'ANNUAL');
          this.cropTypePace = await paceService.getByUuid(sentinela.uuid, sentinela.cropType);
        }
        if (analitica != null) {
          this.annualPaceAnalitica = await paceService.getByUuid(analitica.uuid, 'ANNUAL');
          this.cropTypePaceAnalitica = await paceService.getByUuid(analitica.uuid, analitica.cropType);
        }
      } catch (err) {
      }
    }
  }

  private trackResult() {
    this.polling = setTimeout(async () => {
      if (!this.result && (!this.status || !this.status.finishedWithError)) {
        await this.loadResult();
      }

      if (!this.status || this.status.processing) {
        await this.loadStatus();
      }

      if (this.needsTracking) {
        this.trackResult();
      }
    }, 7000);
  }

  private beforeDestroy() {
    if (this.setteMapsCheck) {
      this.setteMapsCheck.abort();
      this.setteMapsCheck = null;
    }
    if (this.polling) {
      clearTimeout(this.polling);
      this.polling = null;
    }
    Promise.all([
      analysesService.cleanup(),
      weatherService.cleanup(),
    ]);
  }

  private async loadResult(force: boolean = true) {
    try {
      if (force || (!this.result && (!this.status || !this.status.finishedWithError))) {
        
        if (force) {
          const results = await resultsService.getFarmAnalysisResultList((this.sentinelaFarmAnalysis as FarmAnalysis).uuid, this.harvestSeason);
          this.result = results.find((result) => result.cropType === this.analysis.cropType) ?? results[0];
          this.url = this.result.s3GeoJsonUrl;
        } else {
          this.result = await resultsService.getFarmAnalysisResult(
            (this.sentinelaFarmAnalysis as FarmAnalysis).uuid,
            this.analysis.harvestSeason,
            this.analysis.cropType
          );
          this.url = this.result.s3GeoJsonUrl;
        }
      }
    } catch {}
  }

  private async switchSeason(season: string) {
    if (this.harvestSeason !== season) {
      this.harvestSeason = season;
      await this.loadResult(true);
    }
  }

  private async loadStatus() {
    try {
      if (!this.status || this.status.processing) {
        this.status = await statusService.getByFarmAnalysisUuid(
          this.analysis.uuid,
          (this.sentinelaFarmAnalysis as FarmAnalysis).uuid
        );
      }
    } catch {}
  }

  private get needsTracking() {
    return (
      (!this.result && (!this.status || !this.status.finishedWithError)) ||
      !this.status ||
      this.status.processing
    );
  }

  private get cropsList(): CropsDTO[] {
    return this.$store.getters[`crops/crops`](
      (this.sentinelaFarmAnalysis as FarmAnalysis).uuid
    );
  }

  private get selectedCropsUuid() {
    return this.selectedCrops.flatMap((cropLabel) => {
      return (
        this.cropsList.find((crop) => `${crop.cropLabel}` === cropLabel)
          ?.cropUuid || []
      );
    });
  }

  private get geoJson() {
    const props = {
      id: this.analysis!.farmUuid,
      title: this.analysis!.farmName,
      fill: COLORS[this.colorIndex],
      "fill-opacity": 0.2,
      stroke: COLORS[this.colorIndex],
      "stroke-width": 4,
    };
    return wrapGeometryObject(this.analysis!.farmGeom, props);
  }

  private get geoJsonFileName() {
    return `${this.analysis.farmName}_${
      this.sentinelaFarmAnalysis?.analysisYear ?? ""
    }_${this.result?.cropType ?? "ANY"}.geojson`;
  }

  private get cropTypeIconName() {
    return CropIcons.fromText(this.analysis.summerCropType);
  }

  private get averageTemperatureData(): WeatherData[] {
    return this.$store.state.weather.currentTemperatureAverageContext
      .get(weatherService.getCurrentKey(this.analysis!.farmUuid)) ?? [];
  }

  private get historicalTemperatureData(): WeatherData[] {
    return this.$store.state.weather.historicalTemperatureAverageContext
      .get(weatherService.getHistoricalKey(this.analysis!.farmUuid, this.untilDate.getFullYear())) ?? [];
  }

  private get averageSPI4Data(): WeatherData[] {
    return this.$store.state.weather.currentSPI4AverageContext
      .get(weatherService.getCurrentKey(this.analysis!.farmUuid)) ?? [];
  }

  private get historicalSPI4Data(): WeatherData[] {
    return this.$store.state.weather.historicalSPI4AverageContext
      .get(weatherService.getHistoricalKey(this.analysis!.farmUuid, this.untilDate.getFullYear())) ?? [];
  }


  private async loadWeatherData() {
    await Promise.all([
      weatherService.cleanupTemperature(),
      weatherService.cleanupSPI4()]);
    await Promise.all([
      (async () => {
        await weatherService.fetchCurrentTemperatureAverage(
          this.analysis!.farmUuid
        );
        await weatherService.fetchHistoricalTemperatureAverage(
          this.analysis!.farmUuid,
          this.untilDate
        );
      })(),
      (async () => {
        await weatherService.fetchCurrentSPI4Average(this.analysis!.farmUuid);
        await weatherService.fetchHistoricalSPI4Average(
          this.analysis!.farmUuid,
          this.untilDate
        );
      })()
    ]);
  }
}
